// extracted by mini-css-extract-plugin
module.exports = {"myProfileStates":"MyProfileStates_myProfileStates__jyVyi","siamBannerStyle":"MyProfileStates_siamBannerStyle__PtFdx"};